import { useMemo, useEffect, useState } from "react";
import ReactTable from 'react-table';
import {AddUpdateRoleModal, BackButton, BadgeComponent,Breadcrumbs,DropDownComponent, IconButtonComponent, LoaderComponent, PaginationComponent} from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { VerticalDotsSvg } from "../../assets/svgs";
import { toast } from "react-toastify";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { getRolesList } from "../../redux/slices/roles-list-slice";
import { getRolesListByInstitution } from "../../redux/slices/users-slice";
import { Menus } from "../../constants/menus-constant";
import { useLocation } from "react-router";
import { getRoleManagementInboxData, postAddedRoleReview, postUpdatedRoleReview } from "../../redux/slices/role-management-inbox-slice";

const RoleManagementInbox = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { roles } = useSelector((state) => state.rolesListReducer);
    const { user } = useSelector((state) => state.loginUserReducer);
    const { loading, inboxData, pagination } = useSelector((state) => state.roleManagementInboxReducer);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];
    const isChecker = location.pathname.includes('checker');

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: true,
    };

    const [states, setStates] = useState(initialStates);
    const [form, setForm] = useState();

    const defaultParams = { pagination: states.pagination };

    const getInboxData = (updatedParams) => {
        if (user && updatedParams) {
            dispatch(getRoleManagementInboxData({ user, ...updatedParams, entityType: 'role' }));
        }
    };

    // const handleReload = () => {
    //     getInboxData(defaultParams);
    // };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getInboxData(params);
    };

    const handleFormChange = async (e) => {
        const { name, value, type, checked } = e.target;
        const operation = states.selected?.operation?.toLowerCase();
        const isUserOperation = operation?.includes('user creation') || operation?.includes('user updation');
        const isRoleOperation = operation?.includes('role creation') || operation?.includes('role updation');

        const handleFormUpdate = async () => {
            let updatedFields = { [name]: ['checkbox', 'radio'].includes(type) ? checked : value };

            if (isUserOperation) {
                if (name === 'role') {
                    const institutionValue = await roles.find((r) => r.value === value)?.institutionCode;
                    updatedFields.institution = institutionValue;
                } else if (name === 'is2FAEnable') {
                    updatedFields.otpType = checked ? form.otpType : '';
                }
            } else if (isRoleOperation && name === 'institution') {
                updatedFields.permissions = [];
            }

            setForm((old) => ({ ...old, ...updatedFields }));
        };

        handleFormUpdate();
    };

    const handleCheckboxTreeChange = (value, checked) => {
        setForm((old) => ({
            ...old,
            permissions: checked
                ? [...old.permissions, value]
                : old.permissions.filter((v) => v !== value),
        }));
    };

    const handleSelectRow = (row) => {
        if (row === states.selected && states.isDropdownOpen) {
            setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
        } else {
            setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
        }
    };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    const handleModalOpen = () => {
        const operation = states.selected?.operation?.toLowerCase();
        const isUserOperation = operation?.includes('user creation') || operation?.includes('user updation');
        const isRoleOperation = operation?.includes('role creation') || operation?.includes('role updation');

        if (isUserOperation || isRoleOperation) {
            setStates((old) => ({ ...old, isModalOpen: true }));

            const commonFields = {
                processId: states?.selected?.processId,
                reason: states?.selected?.reason,
            };

            if (isUserOperation) {
                setForm({
                    ...states.selected,
                    ...commonFields,
                    userId: states?.selected?.idOrCode,
                    name: states?.selected?.nameOrDescr,
                    cnic: states?.selected?.cnic ? states?.selected?.cnic.replace(/^(\d{5})(\d{7})(\d{1})$/, '$1-$2-$3') : '',
                    mobileNo: states?.selected?.mobileNo || '',
                    empNumber: states?.selected?.empNumber?.split('-')[0],
                    remarks: states?.selected?.remarks || '',
                    is2FAEnable: states?.selected?.is2FAEnable || false,
                    otpType: states?.selected?.otpType || '',
                    institution: states?.selected?.institution?.value,
                    userStatus: states?.selected?.userStatus?.value,
                    role: states?.selected?.role?.value,
                    forgotPassword: states?.selected?.forgotPassword || false,
                });
            } else if (isRoleOperation) {
                setForm({
                    ...commonFields,
                    code: states?.selected?.idOrCode || undefined,
                    // code: states?.selected?.idOrCode?.split('-')[0],
                    descr: states?.selected?.nameOrDescr,
                    roleStatus: states?.selected?.roleStatus?.value,
                    institution: states?.selected?.institution,
                    permissions: states?.selected?.permissions?.map((p) => JSON.parse(p?.id)),
                });
            }
        }
    };

    const handleModalClose = () => {
        setStates((old) => ({ ...old, isModalOpen: false, selected: null }));
    };

    const handleFormSubmit = (e) => {
        const isAccepted = e;
        const operation = states.selected?.operation?.toLowerCase();

        if (!user || !form) return;

        // const isUserOperation = operation?.includes('user creation') || operation?.includes('user updation');
        const isRoleOperation = operation?.includes('role creation') || operation?.includes('role updation');

        const handleSuccess = (action) => {
            if (action?.payload?.status === 201 || action?.payload?.status === 200) {
                handleModalClose();
                getInboxData(defaultParams);
                dispatch(getRolesList(user));
            }
        };

        // if (isUserOperation) {
        //     if (!form.reason) {
        //         return toast.error('Comment is required');
        //     }

        //     const updateUserForm = {
        //         ...form,
        //         cnic: form.cnic ? form.cnic.replace(/-/g, '') : null,
        //         mobileNo: form.mobileNo || null,
        //         empNumber: `${form.empNumber}-${form.institution}`,
        //         remarks: form.remarks || null,
        //         isaccepted: isAccepted
        //     }

        //     const actionCreator = operation.includes('user creation')
        //         ? postAddedUserReview
        //         : postUpdatedUserReview;

        //     dispatch(actionCreator({ user, body: updateUserForm })).then(handleSuccess);
        // }


        if (isRoleOperation) {
            if (!form.permissions.length) {
                return toast.error('Role cannot be created without any permission');
            }
            if (!form.reason) {
                return toast.error('Comment is required');
            }

            const updatedRoleForm = {
                ...form,
                // code: `${form.code}-${form.institution}`,
                isaccepted: isAccepted
            }

            const actionCreator = operation.includes('role creation')
                ? postAddedRoleReview
                : postUpdatedRoleReview;

            dispatch(actionCreator({ user, body: updatedRoleForm })).then(handleSuccess);
        }
    };

    const actions = [
        { label: isChecker ? 'Review' : 'Edit', action: () => handleModalOpen() },
    ];

    useEffect(() => {
        getInboxData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (inboxData && Array.isArray(inboxData)) {
            setStates((old) => ({ ...old, data: inboxData, pagination: pagination }));
        }
    }, [inboxData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (user && form?.institution && form?.institution !== '') {
            dispatch(getRolesListByInstitution({ user, institution: form?.institution }));
        }
    }, [form?.institution]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    // const columns = [
    //     { field: 'processId', headerName: 'Process ID', width: 150 },
    //     { field: 'idOrCode', headerName: 'ID / Code', width: 120 },
    //     { field: 'nameOrDescr', headerName: 'Name / Description', width: 150 },
    //     { field: 'createdBy', headerName: 'Created / Modified By', width: 160 },
    //     {
    //         field: 'operation',
    //         headerName: 'Operation',
    //         width: 120,
    //         align: 'center',
    //         valueGetter: (row) => {
    //             return (
    //                 <>
    //                     {
    //                         row?.operation &&
    //                         <BadgeComponent label={row?.operation} outline type={row?.operation?.toLowerCase()?.includes('role') ? 'warning' : 'default'} />
    //                     }
    //                 </>
    //             )
    //         },
    //         sortBy: (row) => row?.operation,
    //     },
    //     // {
    //     //     field: 'isaccepted',
    //     //     headerName: 'Status',
    //     //     width: 120,
    //     //     valueGetter: (row) => {
    //     //         return (
    //     //             <>
    //     //                 {
    //     //                     ([true, false].includes(row?.isaccepted) && row?.reason) ? (
    //     //                         <BadgeComponent label={row?.isaccepted ? 'Accepted' : 'Rejected'} type={row?.isaccepted ? 'success' : 'error'} />
    //     //                     ) : (
    //     //                         <BadgeComponent label='Pending' type='default' />
    //     //                     )
    //     //                 }
    //     //             </>
    //     //         )
    //     //     },
    //     //     // sortBy: (row) => row.userStatus.label,
    //     // },
    //     { field: 'reason', headerName: 'Comments', width: 120 },
    //     { field: 'reqInitDateTime', headerName: 'Request Date', width: 170, align: 'center' },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         sortable: false,
    //         width: 100,
    //         align: 'right',
    //         sticky: 'right',
    //         valueGetter: (row) => {
    //             return (
    //                 <div className="action-dropdown" style={{ position: 'relative', float: 'right' }}>
    //                     <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row)} />
    //                     <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row} close={handleCloseDropdown} actions={actions} />
    //                 </div>
    //             )
    //         },
    //     },
    // ];

    const columns = useMemo(() => [
        {
            accessor: 'reqInitDateTime',
            Header: 'Request Date',
            minWidth: 170,
            style: {
                textAlign: 'center'
            },
            sortable: false,
            filterable: false
        },
        {
            accessor: 'processId', Header: 'Process ID', minWidth: 180,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        // {
        //     accessor: 'processId',
        //     Header: 'Process ID',
        //     minWidth: 120,
        //     Cell: (row) => {
        //         const processId = row?.original?.processId || '';
        //         const midPoint = Math.ceil(processId.length / 2);
        //         const firstLine = processId.substring(0, midPoint);
        //         const secondLine = processId.substring(midPoint);

        //         return (
        //             <div style={{ lineHeight: '1.2' }}>
        //                 <div>{firstLine}</div>
        //                 <div>{secondLine}</div>
        //             </div>
        //         );
        //     },
        //     sortable: false,
        //     filterable: false
        // },
        {
            accessor: 'idOrCode', Header: 'Code', minWidth: 100,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'nameOrDescr', Header: 'Name', minWidth: 150,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'createdBy', Header: 'Created / Modified By', minWidth: 180,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'operation',
            Header: 'Operation',
            minWidth: 140,
            style: {
                textAlign: 'center',
            },
            Cell: (row) => {
                return (
                    <>
                        {
                            row?.original?.operation &&
                            <BadgeComponent label={row?.original?.operation} type={row?.original?.operation?.toLowerCase()?.includes('updation') ? 'warning' : 'default'} />
                        }
                    </>
                )
            },
            sortable: false,
            filterable: false,
        },
        {
            accessor: 'reason', Header: 'Comments', minWidth: 150,
            style: {
                textAlign: 'center'
            },
            sortable: false, filterable: false
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 100,
            // style: {
            //     height: 45, display: 'flex', justifyContent: 'flex-end', alignItems: 'center'
            // },
            Cell: (row) => {
                return (
                    <div className="action-dropdown" style={{ position: 'absolute' }}>
                        <IconButtonComponent outline={!(states.isDropdownOpen && states.selected === row?.original)} size='small' icon={VerticalDotsSvg} onClick={() => handleSelectRow(row?.original)} />
                        <DropDownComponent isOpen={states.isDropdownOpen && states.selected === row?.original} close={handleCloseDropdown} actions={actions} />
                    </div>
                )
            },
            sortable: false,
            filterable: false,
        },
    ], [ states.isDropdownOpen, states.selected ]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
                <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Inbox</h1>
                    {/* <IconButtonComponent icon={ReloadSvg} outline size="small" disabled={loading} onClick={handleReload} className={loading && 'box-spin'} /> */}
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel },
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>
            </AuthPageHead>

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* EMPTY STATE */}
            {/* {
                !loading && states.data && states.data.length === 0 &&
                <EmptyTableComponent text='No data found!' />
            } */}

            {/* PAGE CONTENT */}
            {
                <>
                   <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        {/* <TableComponent rows={states.data} columns={columns} icon={BadgeSvg} />
                    <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} /> */}
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={false}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            // defaultFilterMethod={(filter, row, column) => {
                            //     return true;
                            // }}
                            // onFilteredChange={(filtered, column, value) => {
                            //     const searchCriteria = transformToObject(filtered);
                            //     setComponentState((prevState) => ({
                            //         ...prevState,
                            //         searchCriteria,
                            //         tableLoading: true,
                            //     }));

                            //     handleOnSearch(searchCriteria); // Trigger handle search
                            // }}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {
                states.isModalOpen && states.selected && states.selected?.operation?.toLowerCase().includes('role') &&
                <AddUpdateRoleModal data={form} label={states?.selected?.operation} close={handleModalClose} update={states.isUpdate}
                    handleFormChange={handleFormChange}
                    handleCheckboxTreeChange={handleCheckboxTreeChange}
                    handleFormSubmit={handleFormSubmit}
                    fromMakerChecker
                    slide
                />
            }
        </AuthPageContainer>
    )
}

export default RoleManagementInbox;